import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "fit" }
const _hoisted_2 = {
  key: 1,
  class: "row justify-center"
}
const _hoisted_3 = { class: "required-inputs-wrapper fit row no-wrap" }
const _hoisted_4 = { class: "row justify-center fit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message_wrap = _resolveComponent("message-wrap")!
  const _component_required_input_refactor = _resolveComponent("required-input-refactor")!
  const _component_select_chanel_button = _resolveComponent("select-chanel-button")!
  const _component_disabled_button_wrapper = _resolveComponent("disabled-button-wrapper")!
  const _component_common_button = _resolveComponent("common-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.message.text)
      ? (_openBlock(), _createBlock(_component_message_wrap, {
          key: 0,
          isShowMessageTail: _ctx.isShowMessageTail,
          message: _ctx.message,
          avatar: _ctx.avatar,
          class: "q-mb-sm"
        }, null, 8, ["isShowMessageTail", "message", "avatar"]))
      : _createCommentVNode("", true),
    (_ctx.isLastMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requiredInputs, (input, key) => {
              return (_openBlock(), _createBlock(_component_required_input_refactor, {
                key: key,
                "type-of-input": key,
                control: input,
                showInvalidRequiredInput: _ctx.showInvalidRequiredInputs,
                onChangeControl: _ctx.emitChangeControl,
                class: "fit q-mb-xs required-input"
              }, null, 8, ["type-of-input", "control", "showInvalidRequiredInput", "onChangeControl"]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons.selectChannelButtons, (button, index) => {
              return (_openBlock(), _createBlock(_component_disabled_button_wrapper, {
                disabled: _ctx.disableButton,
                key: index,
                onDisabledClick: ($event: any) => (_ctx.emitClickButton(button)),
                class: "button-wrapper"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_select_chanel_button, {
                    button: button,
                    disabled: _ctx.disableButton,
                    message: _ctx.message,
                    displayType: "widget",
                    onClick: ($event: any) => (_ctx.emitClickButton(button)),
                    class: "button"
                  }, null, 8, ["button", "disabled", "message", "onClick"])
                ]),
                _: 2
              }, 1032, ["disabled", "onDisabledClick"]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons.commonButtons, (button, key) => {
              return (_openBlock(), _createBlock(_component_disabled_button_wrapper, {
                disabled: _ctx.disableButton,
                key: key,
                onDisabledClick: ($event: any) => (_ctx.emitClickButton(button)),
                class: "button-wrapper"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_common_button, {
                    button: button,
                    disabled: _ctx.disableButton,
                    onClick: ($event: any) => (_ctx.emitClickButton(button)),
                    class: "button fit"
                  }, null, 8, ["button", "disabled", "onClick"])
                ]),
                _: 2
              }, 1032, ["disabled", "onDisabledClick"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}